import { useFlags } from "@resource/client-ffs";
import FeatureFlags from "generated/FeatureFlags";

// Must specify a default for all possible values
const defaultPollingIntervals = {
  createGuideFlow: 5000,
  extensionGuideForATSCandidate: 5000,
  extensionSendData: 30000,
  extensionStageData: 30000,
  fetchGuideForGreenhouseCandidate: 2500,
  fetchGuideForMergeApplication: 5000,
  fetchStageOverviewForExtension: 5000,
  interviewScheduler: 2000,
  interviewSchedulerEvents: 3000,
  guides: 120000,
  pitchPageSchedulerConfigData: 5000,
  schedulerConfigForStageTemplateInstallation: 10000,
  schedulingIntegrationData: 10000,
  sendGuideDetails: 30000,
  syncCandidateApplicationInterviews: 10000,
  templatePicker: 10000,
  uploadCareSignature: 60000,
  zeusExtension: 120000,
  zeusGuides: 120000,
  zeusInterviews: 5000,
};

export type PollingIntervalConfig = typeof defaultPollingIntervals;

/**
 * Simple wrapper for reading polling interval config from launch darkly with fallbacks to default values
 */
export const usePollingIntervalConfig = (): PollingIntervalConfig => {
  const { [FeatureFlags.POLL_INTERVAL_CONFIG]: pollingIntervals } = useFlags();

  return new Proxy<PollingIntervalConfig>(pollingIntervals ?? {}, {
    get(target, rawKey) {
      const key = rawKey as keyof typeof target;
      return target[key] ?? defaultPollingIntervals[key] ?? 0;
    },
  });
};
